import { React, useState, useEffect, useCallback } from "react";
import LoginProcessMob from "./loginProcessMob";
import { loadStripe } from "@stripe/stripe-js";
import {
  PaymentElement,
  Elements,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";

const isEmpty = (str) => {
  return !str || !str.trim().length;
};

const Stage2Component = ({ name, europe, vat, onNameChange, onEuropeChange, onVatChange }) => {
  return (
    <div className="w-full flex-1 flex items-center justify-center px-4 ">
      <div className="w-full max-w-md text-black space-y-4">
        <div className="flex items-center">
          <div className="w-1/3 text-left">Name:</div>
          <div className="flex-1">
            <input
              id="name"
              value={name}
              onChange={onNameChange}
              className="w-full text-xl px-2 py-1 border border-gray-300 rounded"
            />
          </div>
        </div>

        <div className="flex items-center">
          <div className="w-full text-left">Europe based?:</div>
          <div className="flex-1">
            <input
              type="checkbox"
              onChange={onEuropeChange}
              checked={europe ? "checked" : ""}
              className="w-5 h-5"
            />
          </div>
        </div>

        {europe && (
          <div className="flex items-center flex-col">
            <div className="w-full text-left">Fiscal Code:</div>
            <div className="flex-1 w-full">
              <input
                value={vat}
                onChange={onVatChange}
                className="w-full text-sm px-0 py-1 border border-gray-300 rounded"
                id="vat"
                placeholder="<country Code><Number>"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

function Stage3({ setNav, afterLogin, logout }) { 
        const [seed, setSeed] = useState(1);
        useEffect(() => {
                 var b = JSON.parse(sessionStorage.getItem("userinfo"));
                  setNav({ prev: true, next: false });
                  if (b) { 
                      setNav({ prev: true, next: true });
                      console.log(JSON.parse(sessionStorage.getItem("buyInfo")));
                  }
              }, []);
    
        return ( 
             
            <div className="flex justify-center items-center w-dvw h-dvh text-black">
                { !sessionStorage.getItem("userinfo")   ?
                <LoginProcessMob callback={afterLogin} />
                :
                    <div className="flex flex-col">
                        <div>
                    ALready Logged in
                </div>
                        <div className="flex justify-center" onClick={() => logout(setSeed)}>Logout</div>
                    </div>
                }
            </div > 
                
    
        )
    }


function BuyProcessMob(props) {
    const [stage, setStage] = useState(
        //sessionStorage.getItem("userinfo") === null ? (props.stage || 1) : 2
        1
  );
  const [wallet, setWallet] = useState("");
  const [afterSale, setAfterSale] = useState({ newprice: 0, forsale: 0 });
  const [europe, setEurope] = useState(false);
  const [name, setName] = useState("");
  const [vat, setVat] = useState("");
  const [message, setMessage] = useState("");
  const [nav, setNav] = useState({ prev: false, next: true });
  const [err, setErr] = useState("");
    
    
  const paymentGW = process.env.REACT_APP_PAYMENTGATEWAY_END_POINT;
  const intentGW = process.env.REACT_APP_GATEWAY;

  const { idea } = props;

  const openInSameTab = (url) => {
    window.open(url, "_self", "noopener,noreferrer");
  };

  function ownWallet() {
    setWallet(process.env.REACT_APP_OWNWALLET);
    var buyInfo = JSON.parse(sessionStorage.getItem("buyInfo"));
    var m = JSON.stringify({
      phraseData: buyInfo.phraseData,
      BuyerUserId: buyInfo.BuyerUserId,
      sellerUserId: buyInfo.sellerUserId,
      phraseId: buyInfo.phraseId,
      wallet: process.env.REACT_APP_OWNWALLET,
      forsale: 0,
      price: buyInfo.price,
    });
    sessionStorage.setItem("buyInfo", m);
    }

  async function ConnectToWallet(setWallet) {
    if (typeof window.ethereum !== "undefined") {
      window.ethereum
        .request({ method: "eth_requestAccounts" })
        .then(function (res) {
          console.log(res);
          setWallet(res[0]);

          var buyInfo = JSON.parse(sessionStorage.getItem("buyInfo"));
          buyInfo.wallet = res[0];
          sessionStorage.setItem("buyInfo", JSON.stringify(buyInfo));
        });

      window.ethereum.on("accountsChanged", handleAccountsChanged);

      function handleAccountsChanged(accounts) {
        if (accounts.length === 0) {
          setWallet("");
        }
      }
    }
  }

  useEffect(() => {
    if (wallet !== "") {
      sessionStorage.setItem("wallet", wallet);
    } else {
      sessionStorage.removeItem("wallet");
    }
  }, [wallet]);

  // Stage2 navigation management
  useEffect(() => {
    if (stage === 2) {
      setNav(prev => {
        let shouldEnableNext = false;

        if (name && name.trim().length > 0) {
          if (!europe) {
            shouldEnableNext = true;
          } else {
            shouldEnableNext = !isEmpty(vat);
          }
        }

        const newPrev = true;
        if (prev.prev !== newPrev || prev.next !== shouldEnableNext) {
          return { prev: newPrev, next: shouldEnableNext };
        }
        return prev;
      });
    }
  }, [stage, name, vat, europe]);

  // Memoized callbacks for Stage2
  const handleNameChange = useCallback((e) => {
    setName(e.target.value);
  }, []);

  const handleEuropeChange = useCallback(() => {
    setEurope(prev => !prev);
  }, []);

  const handleVatChange = useCallback((e) => {
    setVat(e.target.value);
  }, []);

  function WalletConnectDivs() {
    return (
      <div className="w-full h-full flex flex-col items-center justify-center text-black px-6">
        {wallet ? (
          <div className="w-full text-center space-y-4">
            {wallet === process.env.REACT_APP_OWNWALLET ? (
              <>
                <div className="text-base">You are connected to the Hyperwallet</div>
                <div className="text-sm text-gray-600">
                  (that is our wallet where we hold your tokens on your behalf)
                </div>
                <div
                  onClick={() => {
                    setWallet("");
                    sessionStorage.removeItem("wallet");
                  }}
                  className="mouse2 colorWallet inline-block mt-4 cursor-pointer"
                >
                  Disconnect
                </div>
              </>
            ) : (
              <>
                <div className="text-base">You are connected to your wallet</div>
                <div className="text-xs break-all px-2">{wallet}</div>
                <div
                  onClick={() => {
                    setWallet("");
                    sessionStorage.removeItem("wallet");
                  }}
                  className="mouse2 colorWallet inline-block mt-4 cursor-pointer"
                >
                  Disconnect
                </div>
              </>
            )}
          </div>
        ) : (
          <div className="w-full text-center space-y-6">
            <div
              className="text-lg mouse2 selected cursor-pointer"
              onClick={() => {
                ConnectToWallet(setWallet);
              }}
            >
              [ Your Wallet ]
            </div>
            <div className="text-lg">or</div>
            <div
              className="text-lg mouse2 selected cursor-pointer"
              onClick={() => {
                ownWallet();
              }}
            >
              [ HyperWallet ]
            </div>
          </div>
        )}
      </div>
    );
  }

  function Stage1() {
          
       useEffect(() => {
          if (wallet !== "") {
              sessionStorage.setItem("wallet", wallet);
          } else {
              sessionStorage.removeItem("wallet");
          }

          setNav(prev => {
              const shouldEnableNext = wallet !== "";
              if (prev.next !== shouldEnableNext) {
                  return { prev: false, next: shouldEnableNext };
              }
              return prev;
          });
        }, [wallet]);

    return <WalletConnectDivs />;
  }

  const validateAndNext = async () => {
  
      if (isEmpty(name)) {
      setMessage("We need a name");
      setTimeout(() => setMessage(""), 1500);
      return;
    }

    if (europe) {
      if (isEmpty(vat)) {
        setMessage("We need a valid fiscal code");
        setTimeout(() => setMessage(""), 1500);
        return;
      }

      var trimmedVat = vat.trim();
      var result = await fetch(intentGW + "/vat/" + trimmedVat);
      var data = await result.json();

        console.log(data)
        
      if (!data.valid) {
        setMessage("Invalid fiscal code");
        setTimeout(() => setMessage(""), 1500);
        return;
      }
    }

    setStage(stage+1);
  };

  function logout(setSeed) {
    sessionStorage.removeItem("userinfo");
    sessionStorage.removeItem("wallet");
      console.log("logged Out");
      setSeed(Math.random());;
  }

  const CheckoutForm = (props) => {
    const stripe = useStripe();
    const elements = useElements();

    const [errorMessage, setErrorMessage] = useState(null);
    const [Loading, setLoading] = useState(0);
    const [isProcessing, setIsProcessing] = useState(false);

      const handleSubmit = async () => {
          //prev button got to go or disabled!
          
      if (isProcessing) {
        return;
      }
        console.log(1);
      
        setIsProcessing(true);
      setLoading(1);
      
      if (elements == null) {
        setLoading(0);
        setIsProcessing(false);
        return;
      }
console.log(2);
        
      if (stripe == null) {
        setLoading(0);
        setIsProcessing(false);
        return;
      }
        console.log(3);
        
      const { error: submitError } = await elements.submit();
      if (submitError) {
        setErrorMessage(submitError.message);
        setLoading(0);
        setIsProcessing(false);
        return;
      }
      console.log(4);
      const paymentElement = elements.getElement('payment');
      if (!paymentElement) {
        setErrorMessage("Payment element not ready");
        setLoading(0);
        setIsProcessing(false);
        return;
      }
      console.log(5);
      elements.on("ready", () => {});

      var buyinfo = JSON.parse(sessionStorage.getItem("buyInfo"));
      var userinfo = JSON.parse(sessionStorage.getItem("userinfo"));

      var totals = props.totals;
      buyinfo.name = name;
      buyinfo.vat = vat;
      buyinfo.europe = europe;
      buyinfo.tax = totals.tax;
      buyinfo.subtotal = totals.subtotal;
      buyinfo.totalAmount = totals.total;

      try {
        const response = await fetch(intentGW + "/create-intent", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            data: buyinfo,
            token: userinfo.token,
            total: props.total,
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to create payment intent");
        }

        const data = await response.json();
        const clientSecret = data.clientSecret;

        const { error } = await stripe.confirmPayment({
          clientSecret,
          elements,
          confirmParams: {
            return_url: "http://localhost:3000/buy",
            payment_method_data: {
              billing_details: {
                name: props.customerName || 'Customer',
                address: {
                  line1: 'N/A',
                  city: 'N/A',
                  country: 'IT',
                  state: 'N/A',
                  postal_code: '00000',
                }
              }
            }
          },
          redirect: "if_required",
        });

        if (error) {
          setErrorMessage(error.message);
          setTimeout(() => {
            setErrorMessage("");
          }, 3000);
          setLoading(0);
          setIsProcessing(false);
        } else {
            setErrorMessage("Paid!");
            setTimeout(() => {
              setStage(stage+1);
            }, 2000);
        }
      } catch (error) {
        setErrorMessage(error.message || "Error: 2010");
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
        setLoading(0);
        setIsProcessing(false);
      }
    };
   
    const paymentElementOptions = {
      amount: 99999999,
      currency: "eur",
      layout: "tabs",
      paymentMethodOrder: ["card"],
      fields: {
        billingDetails: {
          address: 'never',
        }
      }
    };

    return (
      <div className="w-full border-0">
        <form className="mb-4">
          <PaymentElement options={paymentElementOptions} />
          <div className="h-10 text-xs text-red-500 mt-2 text-center">
            {errorMessage}
          </div>
        </form>

        {!Loading ? (
          <div className="flex items-center justify-center">
            <span className="mouse2 paybutton cursor-pointer" onClick={handleSubmit}>
              [ Pay {euro.format(props.total / 100)} ]
            </span>
          </div>
        ) : (
          <div className="flex items-center justify-center">
            <span className="mouse2 paybutton">[ Please wait ]</span>
          </div>
        )}
      </div>
    );
  };

  let euro = Intl.NumberFormat("en-DE", {
    style: "currency",
    currency: "EUR",
  });


    
    
  function Stage4() {
    const [totals] = useState(getTotal);

      useEffect(() => {
          if (nav.next) { 
              setNav({ prev: true, next: false });
          }
    }, []);

    const stripePromise = loadStripe(
      "pk_test_51SW1wtQrJEge4qHzQQ1iw9MG4CHgfn5zXITJhW511Lb3A8zZb2jfS93O9J8xRUkNtlgRfK2uBEOdZjPx8p2NsnpC00QUsvPgSg"
    );

    const options = {
      amount: getTotal().total,
      currency: "eur",
      mode: "payment",
      appearance: {},
    };

    function getTotal() {
      var buyInfo = JSON.parse(sessionStorage.getItem("buyInfo"));

      var ideaCost = parseInt(buyInfo.price);
      var mintCost;
      var subtotal;
      var tax = 0;
      var total;
      var label;
      var walletType =
        sessionStorage.getItem("wallet") === process.env.REACT_APP_OWNWALLET;

      if (walletType) {
        mintCost = parseInt(process.env.REACT_APP_BASE_PRICE_HYP);
        label = "Buy with HyperWallet: ";
      } else {
        mintCost = parseInt(process.env.REACT_APP_BASE_PRICE_OWN);
        label = "";
      }

      subtotal = ideaCost + mintCost;

      if (europe) {
        tax = Math.round(subtotal * 0.22);
      }

      total = subtotal + tax;

      return { idea: ideaCost, mint: mintCost, subtotal: subtotal, tax: tax, total: total, label: label };
    }

      return (
      <>
        {totals ? (
          <div className="w-dvw h-full place-content-center  flex flex-col items-center px-6 py-4 border-green-500 border-0">
            <Elements stripe={stripePromise} options={options}>
              <div className="w-full text-black text-sm mb-6">
                <table className="w-full">
                  <tbody>
                    {totals.label !== "" ? (
                      <tr>
                        <td className="text-left py-1">{totals.label}</td>
                        <td className="text-right py-1">{euro.format(parseInt(totals.mint / 100))}</td>
                      </tr>
                    ) : null}
                    <tr>
                      <td className="text-left py-1">Idea :</td>
                      <td className="text-right py-1">{euro.format(totals.idea / 100)}</td>
                    </tr>
                    {totals.tax > 0 ? (
                      <>
                        <tr>
                          <td className="text-left py-1">Subtotal :</td>
                          <td className="text-right py-1">{euro.format(totals.subtotal / 100)}</td>
                        </tr>
                        <tr>
                          <td className="text-left py-1">VAT (22%) :</td>
                          <td className="text-right py-1">{euro.format(totals.tax / 100)}</td>
                        </tr>
                      </>
                    ) : null}
                    <tr className="font-bold border-t border-gray-300">
                      <td className="text-left py-2">Total :</td>
                      <td className="text-right py-2">{euro.format(totals.total / 100)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <CheckoutForm total={getTotal().total} totals={getTotal()} customerName={name} />
            </Elements>
          </div>
        ) : null}
     </>
    );
  }


 

    function Stage5() { 
        useEffect(() => {
            if (nav.prev || !nav.next) { 
                setNav({ prev: false, next: true });
            }
           }, []);
           var d = JSON.parse(sessionStorage.getItem("buyInfo"));
        return (
             <div className="login text-black items-center justify-center text-center" >
        Congratulation
        <br />
        you bought the idea!
        <br />
        <br />
        <br />
        <span
          className={
            afterSale.forsale === 1 ? "mouse2 seriesOn" : "mouse2 seriesOff"
          }
          onClick={() => {
            setAfterSale({ newprice: parseFloat(d.price), forsale: 1 });
          }}
        >
          put it for sale
        </span>
        or <br />
        <span
          className={
            afterSale.forsale === 0 ? "mouse2 seriesOn" : "mouse2 seriesOff"
          }
          onClick={() => {
            setAfterSale({ newprice: parseFloat(d.price), forsale: 0 });
          }}
        >
          keep it to yourself
        </span>
      </div>
        )
    }

     function Stage6() {
       var d = JSON.parse(sessionStorage.getItem("buyInfo"));
       
       useEffect(() => {
            if (!nav.prev || !nav.next) { 
                setNav({ prev: true, next: true });
            }
           }, []);
       
    return (
      <>
        {afterSale.forsale ? (
          <div className="w-full h-full flex flex-col items-center justify-center text-black text-center px-6 space-y-4">
            <input
              className="w-full max-w-xs px-4 py-3 text-lg border border-gray-300 rounded text-center"
              placeholder="new price"
              id="price"
              maxLength="10"
              autoFocus
              onChange={(e) => {
                if (e.target.value === "") e.target.value = 0;
                setAfterSale({
                  forsale: afterSale.forsale,
                  price: parseFloat(e.target.value) * 100,
                });
              }}
              value={
                parseFloat(afterSale.price) / 100
                  ? parseFloat(afterSale.price) / 100
                  : 0
              }
            />
            <div className="text-sm">current price</div>
            <div className="text-base">{parseFloat(d.price) / 100} €</div>
            <div className="border-0 h-10 w-dvw text-xs text-red-500">{err}</div>
          </div>
            ) : (   
                setStage(stage+1)
        )}
      </>
    );
     }
    
    
  function Stage7() {
    useEffect(() => {
      if (nav.next) { 
        setNav({ prev: false, next: false });
      }
     }, []);

    return (
      <div className="w-full h-full flex flex-col items-center justify-center text-black text-center px-6 space-y-2">
        <div
          className="underline mouse2 cursor-pointer"
          onClick={() => openInSameTab("/")}>
          Back To The Galaxy
        </div>
      </div>
    );
  }

  async function handlerAfterSale() {
    var d = JSON.parse(sessionStorage.getItem("buyInfo"));
    var userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
    afterSale.id = d.phraseId;
    afterSale.token = userinfo.token;
    afterSale.tokenId = userinfo.id;

    const h = { 
      "Content-Type": "application/json",
      Authorization: "Bearer " + userinfo.token,
    };
    var options = {
      method: "POST",
      headers: h,
      body: JSON.stringify(afterSale),
    };

    await fetch(paymentGW, options)
      .then((response) => response.json())
      .then(function (data) {
        if (data.name === "TokenExpiredError") {
          logout();
          setStage(3)
        }
        if (data.message) { 
          setErr(data.message);
          setTimeout(() => {
          setErr("");
          }, 3000);
          return
        }
        setStage(7);
      })
      .catch(error => {
                    console.log(error);
                })
  }

    function Navigation(props) {
      //vasco
    return (
      <div className="w-full fixed bottom-10 left-0 flex items-center px-6 py-4 bg-white border-0 border-gray-200">
            <div className="w-1/3 flex justify-start">
                {props.prev && (
            <span onClick={() => prev()} className="mouse2 cursor-pointer">
              Prev
            </span>
            )}
            </div>
            <div className="w-1/3 flex justify-center text-black">
               {stage}
            </div>

            <div className="w-1/3 flex justify-end">
                {props.next && (
                    <span onClick={() => next()} className="mouse2 cursor-pointer">
                        Next
                    </span>
                )}
        </div>
      </div>
    );
  }

  function afterLogin() {
    var d = JSON.parse(sessionStorage.getItem("userinfo"));
    var b = JSON.parse(sessionStorage.getItem("buyInfo"));
    b.BuyerUserId = d.id;

    sessionStorage.setItem("buyInfo", JSON.stringify(b));
    sessionStorage.removeItem("wallet");
    
      console.log(d);
      console.log(d); 
      setTimeout(() => {

      setStage(stage + 1);
      }, 3000);
      
  }

 function next() {
        if (stage === 2) { 
            validateAndNext();
            return
        }
   if (stage === 6) { 
     handlerAfterSale();
     return
   }
      setStage(stage + 1);
  }

  function prev() {
    console.log(afterSale);
    if (stage === 7 && afterSale.forsale === 0) { 
      setStage(stage - 2);
      return;
    }  
    if (stage === 1) { 
      window.location.reload();
      return;
    }

      setStage(stage - 1);
  }

    return (
    //begin
        <div className="w-full h-dvh flex flex-col border-0 border-red-500">
            {stage === 1 && (<Stage1 />)}
            {stage === 2 && (
              <Stage2Component
                name={name}
                europe={europe}
                vat={vat}
                onNameChange={handleNameChange}
                onEuropeChange={handleEuropeChange}
                onVatChange={handleVatChange}
                />
                
            )}
            {stage === 3 && (<Stage3 setNav={setNav} afterLogin={afterLogin} logout={logout} />) }
            {stage === 4 && (<Stage4 idea={idea} buyInfo={sessionStorage.getItem("buyInfo")} />)}    
            {stage === 5 && (<Stage5 />)}    
        {stage === 6 && (<Stage6 />)}    
        {stage === 7 && (<Stage7 />)}    
        
            
            
            <div className="flex justify-center items-center text-4xl pointer-events-none absolute top-0 left-0 w-dvw h-dvh border-0 border-green-400 text-black drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,1)]">
                        {message }
                </div>
          <Navigation prev={nav.prev} next={nav.next} />
    </div>
  );
}

export default BuyProcessMob;
